import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../assets/Colors';

export const MAX_VIDEO_HEIGHT = '65.5vh';
export const MIN_VIDEO_HEIGHT = 480;

export const useStyles = makeStyles({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.background.mainDark,
        overflow: 'hidden',
    },
    desktopContainer: {
        flexGrow: 1,
        backgroundColor: Colors.background.light,
    },
    desktopVideoContainerWrapper: {
        minHeight: MIN_VIDEO_HEIGHT,
        height: MAX_VIDEO_HEIGHT,
        maxHeight: MAX_VIDEO_HEIGHT,

        '& video': {
            maxHeight: MAX_VIDEO_HEIGHT,
        },
    },
    fullScreenVideoContainer: {
        height: '100vh',
        maxHeight: '100vh',

        '& video': {
            maxHeight: '100vh',
            height: '100vh !important',
            objectFit: 'cover !important',
            borderRadius: 0,
        },
    },
    desktopVideoContainer: {
        margin: '0px 30px',
        borderRadius: 30,
        backgroundColor: 'black',
    },
    darkBackground: {
        backgroundColor: Colors.background.mainDark,
    },
    desktopChatContainerWrapper: {
        marginRight: 30,
        marginLeft: 15,
        backgroundColor: Colors.background.mainDark,
        minHeight: MIN_VIDEO_HEIGHT,
        height: MAX_VIDEO_HEIGHT,
        maxHeight: MAX_VIDEO_HEIGHT,
        borderRadius: 30,
    },
    desktopChatContainer: {
        height: '95%',
        paddingRight: 20,
        paddingLeft: 20,
    },
    header: {
        color: Colors.main.primary,
        fontSize: 27,
        margin: 10,
        fontWeight: 500,
    },
    settingsTabsContainer: {
        padding: 0,
        backgroundColor: '#eeeeee',
    },
    tabsContainer: {
        minHeight: '100%',
    },
    tabsIndicator: {
        display: 'none',
    },
    tabsContentContainer: {
        backgroundColor: 'white',
        padding: 30,
        minHeight: 600,
    },
    tabSelected: {
        backgroundColor: '#d3d3d3',
        maxWidth: '100%',
    },
    tabIcon: {
        marginRight: 20,
        maxWidth: '15%',
    },
    tabLabel: {
        maxWidth: '75%',
        width: '70%',
        textAlign: 'left',
        textTransform: 'none',
    },
    hideShowIconButton: {
        position: 'absolute',
        bottom: '25vh',
        right: '5vw',
        background: '#ffffff1c',
        width: 40,
        height: 40,
        zIndex: 99999,

        '& img': {
            width: 33,
            height: 33,
            padding: 7,
        },
    },
});
